import {
  FETCHING_LIBRARY_IMAGES, FETCHING_LIBRARY_IMAGES_SUCCEEDED, FETCHING_LIBRARY_IMAGES_FAILED,
  INVALIDATE_LIBRARY_IMAGES, FETCHING_MEDIA_LIBRARY_CATEGORIES, 
  FETCHING_MEDIA_LIBRARY_CATEGORIES_SUCCEEDED, FETCHING_MEDIA_LIBRARY_CATEGORIES_FAILED
} from '../actions/actionTypes';
import { FETCHING_MEDIA_LIBRARY_FOR_CATEGORY, FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_FAILED, FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_SUCCEEDED } from '../actions/actionTypes';
import _ from 'lodash'

const initialState = {
  collection: {
    loading: false, 
    invalidated: true,
    items: [],
    pagination:{
      currentPage: -1,
      totalPages: 1
    },
    categories: []
  
},
stream: {
  loading: false, 
  invalidated: true,
  items: [],
  pagination:{
    currentPage: -1,
    totalPages: 1
  }
}
}

function imageLibraryReducer(state = initialState, action) {
  switch(action.type) {
    case FETCHING_LIBRARY_IMAGES:
      var type = action.payload;

      return Object.assign({}, state, {
        ...state,
        [type]: {
          ...state[type],
          loading: true,
          invalidated: true
        }
      })

    case FETCHING_LIBRARY_IMAGES_SUCCEEDED:
      var type = action.payload.type;
      var images = action.payload.images.records|| [];
      var items = [];

      if(action.payload.images.currentPage == 0) {
        images = action.payload.images.records;
      } else {
        images = [...state[type].items, ...action.payload.images.records];
      }


      return Object.assign({}, state, {
        ...state,
        [type]: {
          ...state[type],
          loading: false,
          invalidated: false,
          items: images,
          pagination: {
            ...state[type].pagination,
            currentPage: action.payload.images.currentPage,
            totalPages: action.payload.images.totalPages
          }
        }
      })

    case FETCHING_LIBRARY_IMAGES_FAILED:
      var type = action.payload.type;

      return Object.assign({}, state, {
        ...state,
        [type]: {
          ...state[type],
          loading: false,
          invalidated: true,
          error: action.payload.error
        }
      })

    case INVALIDATE_LIBRARY_IMAGES:
      var type = action.payload;

      return Object.assign({}, state, {
        ...state,
        [type]: {
          loading: false,
          invalidated: true,
          items: [],
          pagination:{
            currentPage: -1,
            totalPages: 1
          },
          categories: [...state[type].categories]
        }
      })

      case FETCHING_MEDIA_LIBRARY_CATEGORIES:
        var type = action.payload;
  
        return Object.assign({}, state, {
          ...state,
          [type]: {
            ...state[type],
            loading: true
          }
        })
  
      case FETCHING_MEDIA_LIBRARY_CATEGORIES_SUCCEEDED:
        var type = action.payload.type;
        var categories = action.payload.categories || [];
  
        return Object.assign({}, state, {
          ...state,
          [type]: {
            ...state[type],
            loading: false,
            categories: categories
          }
        })
  
        case FETCHING_MEDIA_LIBRARY_CATEGORIES_FAILED:
          var type = action.payload.type;
    
          return Object.assign({}, state, {
            ...state,
            [type]: {
              ...state[type],
              loading: false,
              error: action.payload.error
            }
          })

          case FETCHING_MEDIA_LIBRARY_FOR_CATEGORY:
            var type = action.payload;
      
            return Object.assign({}, state, {
              ...state,
              [type]: {
                ...state[type],
                loading: true,
                invalidated: true
              }
            })
      
          case FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_SUCCEEDED:
            var type = action.payload.type;
            var images = action.payload.images.records|| [];
            var items = [];
            
      
            if(action.payload.images.currentPage == 0) {
              images = action.payload.images.records;
            } else {
              images = [...state[type].items, ...action.payload.images.records];
            }
      
      
            return Object.assign({}, state, {
              ...state,
              [type]: {
                ...state[type],
                loading: false,
                invalidated: false,
                items: images,
                pagination: {
                  ...state[type].pagination,
                  currentPage: action.payload.images.currentPage,
                  totalPages: action.payload.images.totalPages
                }
              }
            })
      
          case FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_FAILED:
            var type = action.payload.type;
      
            return Object.assign({}, state, {
              ...state,
              [type]: {
                ...state[type],
                loading: false,
                invalidated: true,
                error: action.payload.error
              }
            })
    
    default: 
      return state;
  }
}

export { imageLibraryReducer };